import React from "react";
import MenuBar from "../components/MenuBar";

const ManageUsers = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <MenuBar />
      <h2 style={{ backgroundColor: "blue", color: "white", textAlign: "center", padding: "1rem", marginBottom: "2rem" }}>
        Manage Users
      </h2>
      {/* All user management actions are now accessible from the main menu. */}
    </div>
  );
};

export default ManageUsers;